import type { IconData } from '@stacksjs/iconify-core'

export const handLoveSign: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M26.67 4.57h1.52v19.81h-1.52Zm-1.53 22.86H9.91v-1.52H8.38v1.52H6.86V32h21.33v-4.57h-1.52v-3.05h-1.53Zm0 3.05H22.1v-1.53h3.04ZM23.62 3.05h3.05v1.52h-3.05Zm-4.57 15.24h3.05v1.52h-3.05Zm-7.62 1.52H16v1.52h-4.57Z\"/><path fill=\"currentColor\" d=\"M12.95 13.71h-1.52v1.53h3.05v-4.57h3.05v4.57h-3.05v1.52H16v3.05h1.53v-1.52h1.52v-7.62h3.05v7.62h1.52V4.57H22.1v4.57h-7.62V1.52h-1.53zM9.91 0h3.04v1.52H9.91Zm0 18.29h1.52v1.52H9.91Zm1.52-4.58v-1.52H9.91V1.52H8.38v10.67H6.86v1.52zM6.86 24.38h1.52v1.53H6.86Zm-1.52-3.05h1.52v3.05H5.34Zm0-7.62h1.52v1.53H5.34Zm-1.53 1.53h1.53v6.09H3.81Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handLoveSign
